import { createModelStore } from '@/shared/stores/create-model-store'
import { model8InitialModel } from './initial-state'
import { model8DimensionHandlers } from './dimensions'

export const useModel8Store = createModelStore({
  initialModel: model8InitialModel,
  dimensionHandlers: model8DimensionHandlers,
})
